<div class="checklist-ticket-answers__content">
  <app-icon *ngIf="ticket?.has_checklist; else cancel" [size]="'18'" [glyph]="'check-circled'"> </app-icon>
  <ng-template #cancel>
    <app-icon [size]="'18'" [glyph]="'cancel-circled'"></app-icon>
  </ng-template>

  <a *ngIf="answers.length" class="link link--dotted-blue-dark checklist-ticket-answers__link mb-8" (click)="toggleDetails()">
    {{ showDetails ? 'Скрыть все' : 'Показать все' }}
  </a>
</div>

<div *ngIf="showDetails" class="tbl tbl--full tbl--hovered checklist-ticket-answers__table-wrapper">
  <table class="checklist-ticket-answers__table">
    <thead>
      <tr>
        <th>Вопрос Чек-Листа</th>
        <th>Ответ</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let answer of answers" class="checklist-ticket-answers__tr">
        <td>{{ answer.question_text }}</td>
        <td>
          <ng-container [ngSwitch]="answer.question_type">
            <ng-container *ngSwitchCase="questionTypeEnum.ChoicesMultiple">
              {{ answer.answer_choices.join(', ') }}
            </ng-container>
            <ng-container *ngSwitchCase="questionTypeEnum.ChoicesMultipleWithComment">
              <div *ngIf="!choiceComments.has(answer)">{{ answer.answer_choices?.join(', ') }}</div>
              <div *ngFor="let item of choiceComments.get(answer)" class="checklist-ticket-answers__choice">
                <div>{{ item.choice }}</div>
                <div class="checklist-ticket-answers__comment">Комментарий: {{ item.comment }}</div>
              </div>
              <div *ngIf="legacyComments.get(answer)" class="checklist-ticket-answers__comment">Комментарий: {{ legacyComments.get(answer) }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="questionTypeEnum.Choices">
              {{ answer.answer_choices.join(', ') }}
            </ng-container>
            <ng-container *ngSwitchCase="questionTypeEnum.String">
              <ng-container
                [ngTemplateOutlet]="linkTmpl"
                [ngTemplateOutletContext]="{
                  $implicit: answer.answer_text
                }"
              >
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="questionTypeEnum.Image">
              <ng-container *ngFor="let imageLink of answer.answer_images">
                <ng-container
                  [ngTemplateOutlet]="linkTmpl"
                  [ngTemplateOutletContext]="{
                    $implicit: imageLink
                  }"
                >
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ answer.answer_text }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template let-link #linkTmpl>
  <a
    [href]="link"
    class="checklist-ticket-answers__answer-link"
    [ngClass]="{
      'link checklist-ticket-answers__answer-link--active': isURL(link)
    }"
    (click)="handleClick($event)"
  >
    {{ link }}
  </a>
</ng-template>
